module.exports = __webpack_public_path__ + "static/media/Nguyen-Duc-Dat.a14f9209.jpg";